import Utils from './utils';
import SpritePoly from './spritePoly';

/**
 * 
 */
export default class SpritePolySparks extends SpritePoly {

	/**
	 * single PIXI graphics object to render multiple particles,
	 * handles its own lists internally and positions itself at 0,0
	 * so that individual particles can be spawned at regualar game coords.
	 * all particles are rendered in the same color
	 * @param {Object} args
	 * @param {String} args.layer name of layer within current scene to be added to, defaults to 'default'
	 * @param {Number} args.max fixed particle limit, if breached new particles will overwrite old ones default 1000
	 */
	constructor(args) {
		super(args);
		this.initPaths = false;
		this.sparks = [];
		let max = args.max || 1000;
		while(max > 0) {
			this.sparks.push([0,0,0,0,0,0,false]); // pre-fill array with inactive particles
			max--;
		}
		this.pointer = 0;
	}

	init(entity) {
		super.init(entity);
		this.tracers = -0.02;
		this.alpha = 1;
		this.slop = 1;
		this.sparkDamp = 0.08;
		this.sparkDiverge = 0.8;
		this.groundY = 100000;
		this.setMultiColorMode();
	}

	/**
	 * @param {*} x 
	 * @param {*} y 
	 * @param {*} xv 
	 * @param {*} yv 
	 * @param {*} expire miliseconds
	 * @param {*} time negative values for pre-delay
	 * @param {*} color
	 */
	addSpark(x, y, xv, yv, expire=250, time=0, color=0x00bb55) {
		this.pointer %= this.sparks.length;
		this.sparks[this.pointer] = [x, y, xv, yv, expire, time, true, color];
		this.pointer++;
	}

	generateParticlePaths(delta, deltaNormal) {
		this.paths = [];

		// iterate through particles
		for(let i = 0; i < this.sparks.length-1; i++) {
			let p = this.sparks[i];
			if(!p[6]) continue; // inactive
			if(p[5] < 0) {
				// don't appear yet
				p[5] += delta;
			} else {
				if(p[5] > p[4]) {
					// over expiry time
					if(Math.random() > this.sparkDiverge) {
						// diverge
						p[2] += Utils.randomFloat(-0.3,0.3);
						p[3] += Utils.randomFloat(-0.3,0.3);
						p[4] += Utils.randomInt(200,400); // lengthen expiry
					} else {
						// expire
						p[6] = false;
					}
				} else {
					let path = [];
					// start line at current position
					if(p[1] > this.groundY) {
						// reflect off ground
						// cheap & quick, doesn't calculate intersect for inter-frame hits
						p[1] = this.groundY;
						p[3] = -p[3];
					}
					path.push([p[0], p[1], p[7]]); // x, y, color
					p[0]+=p[2]*delta;
					p[1]+=p[3]*delta;
					p[2]*=1-this.sparkDamp*deltaNormal;
					p[3]*=1-this.sparkDamp*deltaNormal;
					p[5]+=delta;
					// end line at new position
					path.push([p[0], p[1]]);
					this.paths.push(path);
				}
			}
		}

	}

	update(delta, deltaNormal) {
		this.generateParticlePaths(delta, deltaNormal);
		super.update(delta, deltaNormal);
	}

}